export default __webpack_public_path__ + "static/media/ic_cal.507a53df.svg";